/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Summary } from '../App.style';

export default () => (
  <>
    <Summary>
      I'm reaching out to apply for your Software Engineer - UI Platform
      position in Europe. I'm currently a Senior Full Stack Engineer and
      Architect at Nationale Nederlanden. I am helping the company modernize
      their development practices and help hire more engineers who share a
      similar mindset. I'm currently leading efforts to introduce automated
      testing, visual regressions, and a shared design system for web and native
      apps. I have over 10 years experience in full stack engineering.
    </Summary>
    <br />
    <Summary>
      I've worked at huge companies with thousands of employees, I've also
      worked at tiny startups with less than 5 people and making a profit. I
      like to approach problems holistically and pragmatically, solving real
      issues and not just their symptoms. I have experience eliminating major
      technical debt, owning large features and entire apps, cleaning
      architectural inefficiencies, as well as team management of engineers and
      designers.
    </Summary>
    <br />
    <Summary>
      I've always tried to work in some capacity with open source development.
      To me, being part of a larger collective effort will always be more
      appealing than starting something new. I like to make companies I work for
      value the resources they are getting for free and have those same
      companies allow me to commit time to maintaining projects we make use of.
      I've contributed to react-native, expo and typescript in smaller
      capacities. More recently, I've had the opportunity to ship a small
      feature to a UI library we are currently using (wix/react-native-ui-lib).
      Instead of completely re-writing the checkbox component, I added the
      necessary functionality needed to style the checkbox to look like our
      brand. Style that wasn't possible without modifications to the underlying
      code. The idea of working for Github, the mecca of open source fills me
      with excitement.
    </Summary>
    <br />
    <Summary>
      After using the product and reading through the job expectations, I feel
      like this UI Platform position at Github could be a really great fit.
      Thanks for taking the time to learn more about me, I truly hope I've given
      you enough reasons for more consideration. I hope to hear from you soon!
    </Summary>
    <br />
  </>
);
